const isValidEmail = (email) => {
    return email.includes('@')
}

export { isValidEmail }